module.exports = __webpack_public_path__ + "img/tarj1-6.55864fa0.svg";